import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaUserCircle, FaBell, FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";
import { auth, db } from "../utils/firebaseconfig";
import { signOut, onAuthStateChanged, sendEmailVerification } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import "../styles/header.css";

function Header() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [user, setUser] = useState({
    isLoggedIn: false,
    name: "",
    isVerified: false,
    email: "",
  });
  const [verificationSent, setVerificationSent] = useState(false);

  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const userDocRef = doc(db, "User", currentUser.uid);
        const userDocSnap = await getDoc(userDocRef);
        const username = userDocSnap.exists() ? userDocSnap.data().username : currentUser.displayName;
        setUser({
          isLoggedIn: true,
          name: username || currentUser.email,
          isVerified: currentUser.emailVerified,
          email: currentUser.email,
        });
      } else {
        setUser({
          isLoggedIn: false,
          name: "",
          isVerified: false,
          email: "",
        });
      }
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = () => {
    navigate("/Login");
  };

  const handleLogout = async () => {
    await signOut(auth);
    setUser({ isLoggedIn: false, name: "", isVerified: false, email: "" });
    setIsDropdownOpen(false);
    navigate("/");
  };

  const handleMyAccount = () => {
    navigate("/MyAccount");
    setIsDropdownOpen(false);
  };

  const handleResendVerification = async () => {
    try {
      if (auth.currentUser) {
        await sendEmailVerification(auth.currentUser);
        setVerificationSent(true);
        setTimeout(() => setVerificationSent(false), 5000);
      }
    } catch (error) {
      console.error("Error sending verification email:", error);
    }
  };

  return (
    <nav className="header">
      <Link to="/" className="header__logo">
        <FaBell style={{ color: "#fac73a", fontSize: "24px" }} /> BELLZ
      </Link>

      <div className="header__profile" ref={dropdownRef}>
        {user.isLoggedIn ? (
          <>
            <div className="username-container">
              <span className="username">{user.name}</span>
              {user.isVerified ? (
                <FaCheckCircle className="verification-icon verified" title="Email verified" />
              ) : (
                <FaExclamationTriangle className="verification-icon unverified" title="Email not verified" />
              )}
            </div>
            <FaUserCircle className="profile-icon" onClick={toggleDropdown} />
            {isDropdownOpen && (
              <div className="profile-dropdown">
                {!user.isVerified && (
                  <div className="verification-section">
                    <div className="verification-message">
                      Your email is not verified
                    </div>
                    <button 
                      className="resend-verification" 
                      onClick={handleResendVerification}
                      disabled={verificationSent}
                    >
                      {verificationSent ? "Email sent!" : "Resend verification"}
                    </button>
                  </div>
                )}
                <Link to="/settings" className="dropdown-item">Settings</Link>
                <div className="dropdown-item" onClick={handleMyAccount}>My Account</div>
                <Link to="/livestream-host" className="dropdown-item">Go Live</Link>
                <Link to="/addproduct" className="dropdown-item">Add Product</Link>
                <div className="dropdown-item logout" onClick={handleLogout}>Logout</div>
              </div>
            )}
          </>
        ) : (
          <>
            <span className="auth-link" onClick={handleLogin}>Login</span>
            <FaUserCircle className="profile-icon" onClick={toggleDropdown} />
            {isDropdownOpen && (
              <div className="profile-dropdown">
                <span className="dropdown-item" onClick={handleLogin}>Signup / Login</span>
              </div>
            )}
          </>
        )}
      </div>
    </nav>
  );
}

export default Header;
